import {getAccessToken, getTenant} from "./jetms-interop"

function upload(form) {
  const url = `${window.env.api}/applications/deliveryconfiguration/delivery/schedules`
  return fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'x-je-tenant': getTenant()
    },
    body: form
  })
}

function download() {
  const url = `${window.env.api}/applications/deliveryconfiguration/delivery/schedules`

  return fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'x-je-tenant': getTenant(),
    }
  })
}

export { upload, download }



// WEBPACK FOOTER //
// ./src/api/schedule.js